import {type ButtonProps, useTransition} from '@logistics-frontend/blocks'
import {useI18n} from '@logistics-frontend/core/i18n'
import {useState} from 'react'

import {PaymentCard} from '../../shared/types'
import {Props} from './PaymentCardList.types'
import {buildKey} from './utils'

const MAX_CARDS_AMOUNT = 5

export function usePaymentCardList(props: Props) {
  const {cards, card, fetchBoundCard, onSuccess} = props
  const [currentCard, setCurrentCard] = useState<PaymentCard | undefined>(card)
  const [{isPending, error}, startTransition] = useTransition<PaymentCard>(undefined, {key: buildKey('bound')})
  const t = useI18n()

  const translates = {
    title: t('card_list_modal.select_payment_method'),
    subtitle: t('card_list_modal.bound_message'),
    button: isPending
      ? t('phoenix.add_new_card.pending', 'Привязываем карту...')
      : error
      ? t('phoenix.add_new_card.error', 'Не удалось привязать карту, повторить?')
      : t('phoenix.add_new_card.submit'),
  } as const
  const variant: ButtonProps['variant'] = isPending ? 'default' : error ? 'error' : 'action'

  function clickHandler(card?: PaymentCard) {
    if (isPending) {
      return
    }

    if (card) {
      return function _clickHandler() {
        startTransition(() => fetchBoundCard(card), {
          onCommit: onSuccess,
        })
      }
    }
  }

  function changeHandler(nextCard: PaymentCard) {
    setCurrentCard(prevCard => (prevCard?.id === nextCard.id ? undefined : nextCard))
  }

  return {
    variant,
    addDisabled: cards.length >= MAX_CARDS_AMOUNT,
    isPending,
    cards,
    currentCard,
    changeHandler,
    clickHandler,
    translates,
  } as const
}
